module.exports = __webpack_public_path__ + "static/media/calculator.1cf88c59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/calculator.jpg
// module id = 123
// module chunks = 0